<template>
  <div class="bg-white pt-3 border rounded shadow-sm text-start p-4">
    <div class="">
      <h3 class="text-l font-bold mb-4">
        Invite administrator
      </h3>
      <div class="">
        <label class="block text-sm leading-5 ">Email</label>
        <input aria-label="Password" name="email" type="email" v-model="email" :class="inputClass" placeholder="Email"/>
      </div>

      <div class="my-3">
        <label class="block text-sm leading-5 mb-1 ">Role<span class="text-red-700">*</span></label>
        <select :class="inputClass" class="bg-transparent" v-model="role_id">
          <option v-for="role in roles" :value="role.id" v-bind:key="role.id">{{ role.name }}</option>
        </select>
      </div>
      <div class="mt-6 text-right">
        <button type="submit" v-on:click="inviteAdmin" v-if="$store.getters.can('create_administrators')"
                class="py-2 px-4 bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
          Invite
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../services/Utils";
import GraphQl from "@/services/graphql.service";

export default {
  name: "InviteAdministratorsComponent",
  props: {
    orgId: String
  },
  data() {
    return {
      loading: false,
      email: '',
      role_id: '',
      errors: [],
      roles: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  mounted() {
    this.getRoles()
  },
  watch: {
    errors: function (errors) {
      this.$root.$emit("alert_error", errors);
    }
  },
  methods: {
    getRoles() {
      GraphQl.sendRequest('{roles{id name}}')
          .then(response => {
            this.roles = response.roles;
          })
    },
    inviteAdmin() {
      this.loading = true;
      this.errors = [];
      if (this.email == null || this.email === '')
        this.errors.push("Email field is required.");
      if (this.role_id == null || this.role_id === '')
        this.errors.push("Role field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/administrators', {
        email: this.email,
        role_id: this.role_id,
        organization: this.orgId,
        confirmation_link: process.env.VUE_APP_URL + '/organizations'
      }).then((result) => {
        this.$root.$emit("alert_success", [result.data.data.message]);
        this.organization = result.data.data.organization;
      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>